import { Button, Flex, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaClipboardList, FaCubes, FaInfo, FaPaperPlane, FaRegFile } from "react-icons/fa";
import { useQueryParams } from "../../../common/useQueryParams";

interface Props {
  navigateToDetails: () => void;
  navigateToReview: () => void;
  navigateToProducts?: () => void;
  navigateToDocuments?: () => void;
  navigateToEspd?: () => void;
  navigateToEventView: () => void;
}

export const Navigation = ({
  navigateToDetails,
  navigateToReview,
  navigateToProducts,
  navigateToDocuments,
  navigateToEspd,
  navigateToEventView,
}: Props) => {
  const params = useQueryParams();
  const currentStep = params.get("step");
  const { t } = useTranslation();
  return (
    <Flex w={"100%"} flexDirection={"column"} pt="4" pl="2">
      <Button
        leftIcon={<Icon as={FaInfo} w="15px" h="15px" />}
        colorScheme="teal"
        variant={currentStep === "details" ? "solid" : "outline"}
        size={"xs"}
        mr={1}
        w="100%"
        display={"flex"}
        justifyContent="start"
        onClick={navigateToDetails}
      >
        {t("Details")}
      </Button>
      {navigateToProducts && (
        <Button
          leftIcon={<Icon as={FaCubes} w="15px" h="15px" />}
          colorScheme="teal"
          variant={currentStep === "products" ? "solid" : "outline"}
          size={"xs"}
          marginRight={1}
          w="100%"
          display={"flex"}
          justifyContent="start"
          mt="1.5"
          onClick={navigateToProducts}
        >
          {t("Products")}
        </Button>
      )}
      {navigateToDocuments && (
        <Button
          leftIcon={<Icon as={FaRegFile} w="15px" h="15px" />}
          colorScheme="teal"
          variant={currentStep === "documents" ? "solid" : "outline"}
          size={"xs"}
          marginRight={1}
          w="100%"
          display={"flex"}
          justifyContent="start"
          mt="1.5"
          onClick={navigateToDocuments}
        >
          {t("Documents")}
        </Button>
      )}
      {navigateToEspd && (
        <Button
          leftIcon={<Icon as={FaClipboardList} w="15px" h="15px" />}
          colorScheme="teal"
          variant={currentStep === "espd" ? "solid" : "outline"}
          size={"xs"}
          marginRight={1}
          w="100%"
          display={"flex"}
          justifyContent="start"
          mt="1.5"
          onClick={navigateToEspd}
        >
          {t("ESPD")}
        </Button>
      )}
      <Button
        leftIcon={<Icon as={FaPaperPlane} w="15px" h="15px" />}
        colorScheme="teal"
        variant={currentStep === "review" ? "solid" : "outline"}
        size={"xs"}
        marginRight={1}
        w="100%"
        display={"flex"}
        justifyContent="start"
        mt="1.5"
        onClick={navigateToReview}
      >
        {t("Review & Send")}
      </Button>
      <Button
        leftIcon={<Icon as={FaArrowLeft} w="15px" h="15px" color="#586173" />}
        colorScheme="gray"
        color="#586173"
        variant={"solid"}
        size={"xs"}
        marginRight={1}
        w="100%"
        display={"flex"}
        justifyContent="start"
        mt="1.5"
        onClick={navigateToEventView}
      >
        {t("Back to request")}
      </Button>
    </Flex>
  );
};
